import { moduleNamespace } from '@Store/config.store';
import { NamespacedStoreState } from '@Types';
import { useSelector } from 'react-redux';

export const useCompanySettings = () =>
	useSelector(
		(state: NamespacedStoreState) =>
			state?.[moduleNamespace].companySettings,
	);
